import { AppRouteURI } from "router/RoleBasedAccess";

export const AppActionType = Object.freeze({
  APP_BUSY: "App:: Set application busy",
  REMOVE_TOAST_MESSAGE: "App:: Remove toast message",
  SET_TOAST_MESSAGE: "App:: Show toast message",
  SET_DRAWER_STATE: "App:: Show/Hide Side list",
  SET_CHART_DRAWER_STATE: "App:: Show/Hide Side Drawer list",
  SET_CHART_DRAWER_STATE_TO_CLOSE: "App:: Hide Side Drawer",
  CHANGE_PAGE: "App:: Change Page",
  SET_WATER_USER_TYPE: "App:: Set Water User Type",
});

export const appLinks = [{ text: "Your Dashboard", route: AppRouteURI.HOME }];
export const userSettings = [
  {
    text: "Members",
    route: AppRouteURI.MEMBERS,
  },
  {
    text: "Invites",
    route: AppRouteURI.INVITES,
  },
  {
    text: "Profile Settings",
    route: AppRouteURI.SETTINGS,
  },
  {
    text: "Feature Settings",
    route: AppRouteURI.FEATURE_SETTINGS,
  },
  {
    text: "Security",
    route: AppRouteURI.SECURITY,
  },
];

export const mobileUserSettings = [
  ...userSettings,
  {
    text: "Logout",
    route: AppRouteURI.LOGOUT,
  },
];

export const desktopUserSettings = [
  { text: "Go back to tool", route: AppRouteURI.SCENARIO },
  ...userSettings,
];
